// extracted by mini-css-extract-plugin
export default {"addButton":"SaasIntegrations_addButton__8Ikbz","tag":"SaasIntegrations_tag__gtdfL","green":"SaasIntegrations_green__HdMua","red":"SaasIntegrations_red__t572T"};